import type { WorldCupForecastState, WorldCupTeamId } from '@wc26-forecast/model/types';
import { clearMatchResultsByTeamIds } from './clearMatchResultsByTeamIds';

export function clearInvalidBestThirdTeams(state: WorldCupForecastState) {
  const removedTeamIds: WorldCupTeamId[] = [];
  Object
    .entries(state.prediction.bestThirdTeams)
    .forEach(([ bestThirdSlot, selectedTeamId ]) => {
      if (!selectedTeamId) {
        return;
      }
      const isStillThirdPlaceTeam = state.groups.ids.some((groupId) => (
        state.prediction.groupPlacements[groupId]?.[3] === selectedTeamId
      ));
      if (!isStillThirdPlaceTeam) {
        state.prediction.bestThirdTeams[bestThirdSlot as keyof typeof state.prediction.bestThirdTeams] = null;
        removedTeamIds.push(selectedTeamId);
      }
    });
  if (removedTeamIds.length > 0) {
    clearMatchResultsByTeamIds(state, removedTeamIds);
  }
}
